export const env = {
  jumbaAPIKey: 'AIzaSyDfUAqkwy5PNvRF2aikxdr3mMq7wCMuMK8',
  grant: 'customer_password',
  scope: 'portal'
}
